export default function DeleteButton() {
    return (
        <i className="icon change_password" />
    )
}